import {
    PAGE_TYPE
  } from '../constants/AppConstants';
  
  const initialState = {
    type: '',
  };
  
  export default (state = initialState, action) => {
    
    switch (action.type) {
      case PAGE_TYPE: {
        return {
          ...state,
          type: action.pageType
        }
      }
      
      default: {
        return state;
      }
    }
  };
  